import React from 'react';
import { gotoPage } from '../history';
// ui
import { Typography } from 'rmwc/Typography';
// comps
import ContentCard from '../components/ContentCard';

const Home = () => {
    const headerStyle = { textAlign: 'center' };
    const introStyle = { paddingTop: 20, paddingBottom: 20, maxWidth: 700, margin: '0 auto' };

    return (
        <div>
            <Typography use={'headline3'} style={headerStyle} tag={'h1'}>
                Dalton Poppy Plaques
            </Typography>

            <div className={'limitedWidthSection'}>
                <Typography tag={'div'} use={'body1'} style={introStyle}>
                    In commemoration of the young men of Dalton in Furness and Newton in Furness who gave their
                    lives in
                    World War One.
                </Typography>
            </div>


            <div className={'contentCardsHolder'}>
                <ContentCard onClick={() => gotoPage('theFallen')}
                             img={'poppies-pic.PNG'}
                             title={'The Fallen Soldiers'}>
                    Search, browse and read about all the Dalton soldiers who died in the first world war.
                </ContentCard>

                <ContentCard onClick={() => gotoPage('project')}
                             img={'img_6035.JPG'}
                             title={'About the project'}
                             buttonLabel={'Read'}>
                    See how Dalton created poppy plaques for every home from which a WW1 soldier left but did not return.
                </ContentCard>

                <ContentCard onClick={() => gotoPage('ww1')}
                             img={'local-recruits-royal-lancaster-reg.jpg'}
                             title={'About WW1'}
                             buttonLabel={'Read'}>
                    Read about Life in the Trenches and how bullets weren't the only killer.
                </ContentCard>

                <ContentCard onClick={() => gotoPage('bbcRadioCumbria')}
                             img={'bbc-link-pic.PNG'}
                             title={'WW1 at Home on BBC Radio Cumbria'}
                             buttonLabel={'Listen'}>
                    Listen to stories about what happened locally when the world went to war.
                </ContentCard>
            </div>

        </div>
    )
};

export default Home;


// WEBPACK FOOTER //
// ./src/app/pages/Home.js